import {useClientStorage, useTranslateStorage} from "@/stores/store";
import {DEFAULT_LANGUAGE_CODE} from "@/shared/constants/consts";
import {storeToRefs} from "pinia";

export const loadLocale = (lang) => {
    const translateStorage = useTranslateStorage();
    const { language_strings } = storeToRefs(translateStorage);

    if(lang === 'en') {
        return import("@/locale/en").then(r => {
            language_strings.value = r.language_strings

            return {resultInitView: true};
        });
    }
    else {
        return import("@/locale/ru").then(r => {
            language_strings.value = r.language_strings

            return {resultInitView: true};
        });
    }
}

export const LS =(key) =>
{
    const clientStorage = useClientStorage();
    const lang = clientStorage.clientObj.lang;

    const translateStorage = useTranslateStorage();

    if(lang === DEFAULT_LANGUAGE_CODE) {
        return key;
    }

    ////console.log('language_strings', translateStorage.language_strings, 'key', key);

    if(!Object.prototype.hasOwnProperty.call(translateStorage.language_strings, key))
    {
        //console.log('!language_strings.hasOwnProperty(key)', key);
        return key;
    }

    return translateStorage.language_strings[key];
}